export const MAX_FILE_SIZE: number = 5242880;

export const MAX_SIZE_ERROR_MESSAGE =
  'Only image files that are 5MB or smaller are supported.';
